import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e3ed4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlanningCourier" }
const _hoisted_2 = { class: "PlanningCourier__header" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header__avatar" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" })
], -1))
const _hoisted_5 = { class: "header__contacts ml-3" }
const _hoisted_6 = { class: "contacts__name" }
const _hoisted_7 = { class: "contacts__phone" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fa-xs fa-rotate-90 mr-2" }, null, -1))
const _hoisted_9 = { class: "PlanningCourier__content" }
const _hoisted_10 = {
  class: "flex flex-col",
  style: {"min-width":"130px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Сектор", -1))
const _hoisted_12 = { class: "text-sm font-semibold" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Смена", -1))
const _hoisted_15 = {
  key: 0,
  class: "text-sm font-semibold"
}
const _hoisted_16 = {
  key: 1,
  class: "text-sm font-semibold"
}
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Загруженность авто", -1))
const _hoisted_19 = { class: "flex flex-col" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, "Количество доставок", -1))
const _hoisted_21 = { class: "text-sm font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_planning_courier_fullness = _resolveComponent("planning-courier-fullness")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.courier.name), 1),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_ctx.courier.phoneNumber), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courier.sectors, (sector, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: sector.id
            }, [
              (i === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(sector.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(", " + _toDisplayString(sector.name), 1)
                  ], 64))
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        (_ctx.courier.schedule)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.courier.schedule.workTimeFrom) + " - " + _toDisplayString(_ctx.courier.schedule.workTimeUntil), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_16, "-"))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_planning_courier_fullness, {
          "car-type": _ctx.courier.carType,
          fullness: _ctx.courier.fullness
        }, null, 8, ["car-type", "fullness"])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.courier.invoiceQuantity), 1)
      ])
    ])
  ]))
}